import React from 'react';
import Contact from './screens/contact-component/Contact';
import About from './screens/about-component/About';
import Home from './screens/home-component/Home';
import Project from './screens/Project-component/Project';
import Logo from "./assets/img/logo.png";
import './App.scss';
import { Row, Col,Button,Layout,Tooltip } from 'antd';
import { FacebookFilled } from '@ant-design/icons';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
const { Header, Content, Footer, Sider } = Layout;
function CopyEmail() {
  const el = document.createElement('textarea');
  el.value = "str";
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
function App() {
  return (
    <div>
        <Router>
          <div className="navbar ">
            <header className="container">
              <Row >
                <Col className="gutter-row" span={6}>
                  <article className="logo ">
                    <Link to="/"><img src={Logo} alt="logo" /></Link>
                  </article>
                </Col>
                <Col className="gutter-row" span={12}>
                    <ul className="list w-100">
                      <li>
                        <Link to="/home">Home</Link>
                      </li>
                      <li>
                        <Link to="/about">About</Link>
                      </li>
                      <li>
                        <Link to="/blog">Blog</Link>
                      </li>
                    </ul>
                </Col>
                <Col className="gutter-row" span={6}>
                  <article className=" ">
                    <Link className="right rounded-pill btn-contact" to="/contact">Contact</Link>
                  </article>
                </Col>
              </Row>
            </header>
          </div>
            <Content theme="dark">
              <Switch>
                <Route exact path="/about" component={About} />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/home" component={Home } />
                <Route exact path="/project" component={Project} />
                <Route exact path="/" component={Home} />
              </Switch>
            </Content>
          <footer>
            <section className="container" style={{marginBottom:0}}>
              <h4 style={{color:'#ccc'}}>Get in touch</h4>
              <h1 style={{fontSize:42}}>Let's work together</h1>
              <p style={{marginBottom:35}}>Get started today and make your own fast and elegante application with last feature</p>
              <Tooltip title="Click to copy Email">
                <Button type="primary" shape="round" onClick={CopyEmail}>benallalsoufiane1@gmail.com</Button>
              </Tooltip>
              <br />
              <small className="reply"><b>Reply time</b>: within 24 hours</small>
              <article className="social-network">
                <ul>
                
                  <li><FacebookFilled /></li>
                  <li><ion-icon size="large" name="logo-twitter"></ion-icon></li>
                  <li><ion-icon size="large" name="logo-google"></ion-icon></li>
                  <li><ion-icon size="large" name="logo-whatsapp"></ion-icon></li>
                  <li><ion-icon size="large" name="logo-instagram"></ion-icon></li>
                  <li><ion-icon size="large" name="logo-linkedin"></ion-icon></li>
                  <li><ion-icon size="large" name="logo-github"></ion-icon></li>
                </ul>
              </article>
              <small>2020 all rights reserved powered by beyonders team</small>
            </section>
          </footer>
        </Router>
    </div>
  );
}


export default App;
